<template>
  <div class="longtermuser">
    <BaseTitle titleText="長照用戶管理" />
    <section class="longtermuser__banner">
      <b-form class="mb-0">
        <label class="mr-3 mb-0">姓名</label>
        <b-form-input
          :value="usersPagenation.keyword"
          @input="handleKeyword"
          class="w-25 d-inline-block mr-3"
          placeholder="輸入姓名"
        ></b-form-input>
        <b-button @click.prevent="searchUsers">搜尋</b-button>
        <router-link class="longtermuser__add" :to="{ name: 'LongTermUserAdd' }"
          >+ 新增長照用戶</router-link
        >
      </b-form>
    </section>

    <section class="longtermuser__form pt-3">
      <b-form-select
        :value="usersPagenation.perPage"
        :options="perPageOptions"
        @input="handlePerPage"
        class="longtermuser__form-perpage"
      >
      </b-form-select>

      <b-table
        id="longTermUsersTable"
        head-variant="light"
        :hover="true"
        :items="users"
        :fields="usersFields"
        @sort-changed="onSortSubidyFare"
      >
        <template #cell(action)="{ item }">
          <b-button
            class="longtermuser__form-button"
            pill
            @click="
              $router.push({
                name: 'longTermUser',
                params: { id: item.id }
              })
            "
            >檢視</b-button
          >
        </template>
      </b-table>
      <div v-if="!users.length" class="text-center mb-3">暫無資料</div>

      <div class="text-right pr-2">
        <b-pagination
          :value="usersPagenation.currentPage"
          :total-rows="usersPagenation.totalEntries"
          :per-page="usersPagenation.perPage"
          @input="handleCurrentPage"
          aria-controls="longTermUsersTable"
          class="mb-5"
        ></b-pagination>
      </div>
    </section>
  </div>
</template>

<script>
import BaseTitle from '@/components/base/BaseTitle';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'LongTermUsers',
  components: {
    BaseTitle
  },
  data() {
    return {
      usersFields: [
        {
          key: 'id',
          label: '編號'
        },
        {
          key: 'name',
          label: '姓名'
        },
        {
          key: 'areaType',
          label: '區域類型'
        },
        {
          key: 'selfPayRatio',
          label: '自費比例'
        },
        {
          key: 'telephoneNumber',
          label: '住家電話'
        },
        {
          key: 'firstMobilePhoneNumber',
          label: '手機'
        },
        {
          key: 'subsidyMaximumAmount',
          label: '上限金額'
        },
        {
          key: 'subsidyLastAmount',
          label: '本月剩餘金',
          sortable: true,
          class: 'th-xs-width'
        },
        {
          key: 'action',
          label: '動作'
        }
      ],
      perPageOptions: [25, 50, 100]
    };
  },
  methods: {
    ...mapActions({
      fetchUsers: 'longTerm/fetchUsers'
    }),
    handleKeyword(keyword) {
      this.keyword = keyword;
      this.$store.commit('longTerm/usersPagenation', {
        ...this.usersPagenation,
        keyword
      });
      this.fetchUsers(this.usersPagenation);
    },
    searchUsers() {
      this.fetchUsers(this.usersPagenation);
    },
    handlePerPage(perPage) {
      this.$store.commit('longTerm/usersPagenation', {
        ...this.usersPagenation,
        perPage
      });
      this.fetchUsers(this.usersPagenation);
    },
    handleCurrentPage(currentPage) {
      this.$store.commit('longTerm/usersPagenation', {
        ...this.usersPagenation,
        currentPage
      });
      this.fetchUsers(this.usersPagenation);
    },
    async onSortSubidyFare(e) {
      this.$store.commit('longTerm/usersPagenation', {
        ...this.usersPagenation,
        subidyFare: e.sortDesc ? 'desc' : 'asc'
      });
      await this.fetchUsers(this.usersPagenation);
    }
  },
  computed: {
    ...mapGetters({
      users: 'longTerm/users',
      usersPagenation: 'longTerm/usersPagenation'
    })
  }
};
</script>

<style lang="scss" scoped>
.longtermuser {
  font-size: 14px;

  button {
    font-size: 14px;
  }

  &__title {
    margin: 20px 0;
    text-align: center;
    font-weight: 400;
    font-size: 22px;
    color: #73879c;
  }

  &__banner {
    background-color: #ecf0f5;
    padding: 20px 15px 20px 20px;
    form {
      margin-bottom: 20px;
      button {
        vertical-align: middle;
        background-color: #409eff;
        border: none;
        margin-right: 20px;
      }
    }
  }

  &__form {
    padding: 0 15px;

    &-perpage {
      width: 200px;
      margin-bottom: 20px;
    }

    &-button {
      display: block;
      margin-bottom: 3px;
      color: #409eff;
      background: #ecf5ff;
      border-color: #b3d8ff;
      padding: 6px 20px;
    }

    .pagination {
      float: right;
    }
  }

  &__add {
    display: inline-block;
    padding: 0.375rem 0.75rem;
    background-color: #67c23a;
    vertical-align: middle;
    border-radius: 5px;
    color: #fff;
    line-height: 1.5;
    &:hover {
      text-decoration: none;
    }
  }
}

.form-control {
  width: auto;
  font-size: 14px;
  vertical-align: middle;
}

::v-deep .table td {
  vertical-align: middle;
}

::v-deep .table .thead-light th {
  background-color: #ededed;
  color: #909399;
}

::v-deep .table thead th {
  border: none;
}

::v-deep .table tr:first-child td {
  border: none;
}

::v-deep .table {
  color: #606266;
}
</style>
